import React from "react";
import { Calendar, HeartHandshake, Sprout, Flag } from "lucide-react";

const items = [
  { icon: Calendar, title: "Since 2017", desc: "Eight joyful years of nurturing early learners in Kirtipur.", color: "bg-light-blue", iconColor: "text-brand-blue" },
  { icon: HeartHandshake, title: "Child-centered", desc: "Every classroom decision starts with the child's curiosity.", color: "bg-soft-orange", iconColor: "text-brand-blue" },
  { icon: Sprout, title: "Whole-child growth", desc: "Physical, language, social-emotional, and creative development.", color: "bg-light-green", iconColor: "text-brand-blue" },
  { icon: Flag, title: "Nepalese concept", desc: "Rooted in our culture, language and values from the very start.", color: "bg-light-blue", iconColor: "text-brand-blue" },
];

const Highlights = () => (
  <section className="py-16 sm:py-24" data-testid="highlights-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">What makes us special</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2">A school built around your child</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((it, i) => (
          <div key={i} className={`card-soft p-7 ${it.color}`} data-testid={`highlight-${i}`}>
            <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-5">
              <it.icon className={it.iconColor} size={24} />
            </div>
            <h3 className="font-heading font-bold text-lg mb-2">{it.title}</h3>
            <p className="text-sm text-[color:var(--text-secondary)] leading-relaxed">{it.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Highlights;
